import { CandidateService } from '../../../../services/candidateService';
import ClientUserService from '../../../../services/client-services/clientUserService';
import { ClientService } from '../../../../services/clientService';
import { MasterDataService } from '../../../../services/masterDataService';

export const handleClientSubmission = async (
  data,
  setLoader,
  clientId,
  isEditMode
) => {
  setLoader && setLoader(true);

  const normalizePayload = (values) => {
    const payload = {
      ...values,
      companyAddrPinCode: String(values.companyAddrPinCode || ''),
      gstAddressPinCode:
        values.gstAddressDiffFromCompanyAddress === 'YES'
          ? String(values.gstAddressPinCode || '')
          : null,
      gstAddress:
        values.gstAddressDiffFromCompanyAddress === 'YES'
          ? values.gstAddress
          : null,
    };

    delete payload.pinCodeDetails;
    delete payload.companyAddrPinCodeDetails;
    delete payload.gstAddressPinCodeDetails;
    delete payload.clientDocs;
    delete payload.clientUsers;
    delete payload.clientStatus;
    delete payload.shortlists;
    delete payload.subscriptions;

    if (payload.contactPerson) {
      payload.contactPerson = {
        ...payload.contactPerson,
        clientRole: payload.contactPerson.clientRole || 'PRIMARY',
        dpFileContent: [],
        docs: []
      };
    }

    return payload;
  };

  try {
    const payload = normalizePayload(data);

    let res;
    if (isEditMode) {
      res = await ClientService.updateClient(payload);
      alert('Client Updated successfully.');
    } else {
      res = await ClientService.addClient(payload);
      alert('Client Added successfully.');
    }

    return res;
  } catch (err) {
    alert(err.response?.data?.message || err.message);
    throw err;
  } finally {
    setLoader && setLoader(false);
  }
};

export const handleClientFileChange = async (
  event,
  clientId,
  setLoader,
  setLoadedData
) => {
  const file = event.target.files?.[0];
  if (!file) return;

  try {
    setLoader(true);
    await ClientUserService.uploadClientPrimaryDocs(clientId, file);
    const updatedClient = await ClientService.getClientById(clientId);
    const clientData = updatedClient.data.clients[0];
    setLoadedData(clientData);
    alert('Document uploaded successfully');
  } catch (err) {
    alert(err.response?.data?.message || err.message);
  } finally {
    setLoader(false);
    event.target.value = '';
  }
};

export const handlePinChange = (base, pin, setFieldValue) => {
  MasterDataService.getPinDetail(pin)
    .then((data) => {
      if (data.data) {
        setFieldValue(`${base}.state`, data.data.state);
        setFieldValue(`${base}.district`, data.data.district);
        setFieldValue(`${base}.pinCode`, data.data.pinCode);
      } else {
        if (pin.length < 6 || pin.length > 6) {
          alert('Please enter a valid pin code.');
        }
      }
    })
    .catch((err) => {
      alert('Please enter a valid pin code.');
      setFieldValue(`${base}.state`, '');
      setFieldValue(`${base}.district`, '');
      setFieldValue(`${base}.pinCode`, '');
    });
};